import { royalty, alienParasite } from 'theme/palette';
import { Plan } from "components/Pricing/types";

export const COLORS = {
  check:   alienParasite.main,   // #59fc3c
  cta:     royalty.main,         // #5a2f9e
  ctaHover: royalty.shade20,     // #48267e (was #4a237e)
  cardBg:  '#ffffff',
} as const;

export const under30Plans: Plan[] = [
  {
    id: "u30-full-pass",
    title: "Full pass",
    price: 600,
    currency: "DKK",
    billingNote: "per month",
    description: ["Unlimited weekly classes", "Events included"],
    buttonText: "Choose",
    buttonVariant: "outlined",
    buttonUrl: "https://buy.stripe.com/fZeeYneOMabKaIw9AD",
  },
  {
    id: "u30-once-a-week-pass",
    title: "Once a week pass",
    price: 400,
    currency: "DKK",
    billingNote: "per month",
    description: ["1 class per week", "Events included"],
    subheader: "Members' favourite",
    highlight: true,
    buttonText: "Choose",
    buttonVariant: "contained",
    buttonUrl: "https://buy.stripe.com/aEUbMb7mkabK9Es002",
  },
  {
    id: "u30-one-time-class",
    title: "Drop-in class",
    price: 108,
    currency: "DKK",
    billingNote: "one time",
    description: ["Single drop-in session", "Valid 1 month (non-refundable, rebookable)"],
    buttonText: "Buy",
    buttonVariant: "outlined",
    buttonUrl: "https://buy.stripe.com/28EbJ1cfqb2a2F17G2fMA0e",
  },
];

export const over30Plans: Plan[] = [
  {
    id: "o30-full-pass",
    title: "Full pass",
    price: 750,
    currency: "DKK",
    billingNote: "per month",
    description: ["Unlimited weekly classes", "Events included"],
    buttonText: "Choose",
    buttonVariant: "outlined",
    buttonUrl: "https://buy.stripe.com/7sY9ATbbm0nw1AX1hEfMA0g",
  },
  {
    id: "o30-once-a-week-pass",
    title: "Once a week pass",
    price: 500,
    currency: "DKK",
    billingNote: "per month",
    description: ["1 class per week", "Events included"],
    subheader: "Members' favourite",
    highlight: true,
    buttonText: "Choose",
    buttonVariant: "contained",
    buttonUrl: "https://buy.stripe.com/aFa5kDbbm7PY7Zl3pMfMA0h",
  },
  {
    id: "o30-one-time-class",
    title: "Drop-in class",
    price: 135,
    currency: "DKK",
    billingNote: "one time",
    description: ["Single drop-in session", "Valid 1 month (non-refundable, rebookable)"],
    buttonText: "Buy",
    buttonVariant: "outlined",
    buttonUrl: "https://buy.stripe.com/6oU28rbbmgmu5RdaSefMA0f",
  },
];
